<template>
  <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" id="photos_Modal" style="min-height: 22rem;">
    <div class="modal-dialog" style="max-width: 78rem">
      <div class="modal-content" id="photoModal">
        <div class="modal-body pb-0 pl-0" id="simple_photo_checkbox">
          <div class="row">
            <div class="col-md-3">
<!--              filter side bar -->
                 <SideNav/>
            </div>
            <div class="col-sm-9 pl-0">
              <span class="float-right" @click="closeModal()">
                <i class="fa fa-times curser-pointer"></i>
              </span>
              <p class="w-100 mb-2 text-dark" style="font-size: 1.45rem">
                {{ $t('add_photos') }}
              </p>
              <div class="row row-cols-5 pl-0 pr-3 screen-height" id="simple_photo">
                <div class="col pr-0 pl-2" v-for="(photo,index) in photos" :key="index">
                  <div class="simple-photo" :class="{'modal-images-popup': (index % 5) === 0 }">
                    <PhotoInfoPopup :photo="photo" :isConstruction="false" />
                    <input
                      type="checkbox"
                      class="border d-none border-danger"
                      v-model="tempImages"
                      :id="`img-index${index}`"
                      :value="{
                          pdphotoid: photo.pdphotoid,
                          pdphototext: photo.description,
                          description: photo.description,
                          pduserid: photo.pduserid,
                          runid: photo.runid,
                          projectid: photo.projectid,
                          photodate: photo.photodate,
                          params: photo.params,
                          origname: photo.origname,
                          phototype: photo.phototype
                      }">
                    <label :for="`img-index${index}`">
                      <div  data-aspect-ratio="4:3" class="img-fluid">
                        <div :style="{'background-image': 'url(\''+ `${photoUrl}&projectid=${photo.projectid}&id=${photo.pdphotoid}` + '\')'}"></div>
                      </div>
                    </label>
                    <div class="simple-photo-option">
                      <ul>
                        <li>Nr. {{photo.runid}}</li>
                        <li>|</li>
                        <li>{{photo.photodate | setDate}}</li>
                        <li>|</li>
                        <li>{{ photo.photodateBytime }}Uhr</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-1 border-top pb-2">
                <sliding-pagination
                  :current="$store.state.photo.page"
                  :total="$store.state.photo.TPage"
                  @page-change="pageChangeHandler"
                  :classMap='{
                   "componentClass": "pagination-bottom border-top pt-2",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link" }'/>
                <div class="float-right p-1" style="margin-top: -30px">
                  <button type="button" @click="closeModal" class="btn btn-danger font13 font-weight-normal" style="padding: 4px 15px;line-height: inherit">
                    Abbrechen
                  </button>
                  <button type="button" @click="setImages" class="btn btn-success font13 font-weight-normal" style="padding: 4px 15px;line-height: inherit">
                    Hinzufügen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideNav from '../../photo/components/SideNav'
import SlidingPagination from 'vue-sliding-pagination'
import PhotoInfoPopup from '../../constructionDiary/components/SideBar/PhotoInfoPopup'
import {formatDate} from '../../common'
export default {
  components: {SideNav, SlidingPagination , PhotoInfoPopup},
  computed: {
    /**if we use method then it's runs again and again you scroll page
     *This property created only once
     * photo Base url
     */
    photoUrl: () => `${process.env.VUE_APP_GET_METHOD_URL}img&token=${localStorage.sessiontoken}&type=l`,
    checkedPhotos : {
      get(){
        return this.$store.state.photoDocumentation.selectedImages
      }, set(val){
        this.$store.commit('setSelectedImages', val)
      }
    },
    tempImages : {
      get(){
        return this.$store.state.photoDocumentation.tempPhotos
      },set(val){
        this.$store.commit('setTempPhotos', val)
      }
    },
    photos () {
      return this.$store.state.photo.photos
    }
  },
  filters: {
    setDate: (date) => formatDate(date)
  },
  methods: {
    pageChangeHandler (selectedPage) {
      this.$store.state.photo.page = selectedPage
      this.$root.$emit('pageChangeHandler', selectedPage)
    },
    closeModal () {
      let ary = []
      this.checkedPhotos.forEach(item => {
        const photo = JSON.parse(JSON.stringify(item));
        const pic = this.tempImages.find(im => im.pdphotoid == photo.pdphotoid);
        if (pic)
        ary.push(pic)
        else
        ary.push(photo)
       })
      this.tempImages = [...ary]
      $('#photos_Modal').modal('toggle')
    },
    setImages(){
      let ary = []
      this.tempImages.forEach(item => {
        const photo = JSON.parse(JSON.stringify(item));
        console.log('SetImages Add',this.checkedPhotos, item)
        const img  = this.checkedPhotos.find(im => im.pdphotoid == photo.pdphotoid);
        if (img)
        ary.push(img)
        else
        ary.push(photo)
      });
      this.checkedPhotos = [...ary]
      $('#photos_Modal').modal('toggle')
    }
  }
}

</script>
<style scoped>
#mySidenav{
  width: 91% !important;
  margin-left: 5px !important;
  position: initial;
}
.sidenav {
  height: calc(100vh - 60px);;
}
.componentClass{
  width: fit-content;
}
.curser-pointer{
  cursor: pointer;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/PhotosModal.vue